import React, { useState, useEffect } from "react";
import {
  Icon,
  TreeSelect,
  Select,
  Checkbox,
  AutoComplete,
  Drawer,
  Tooltip,
} from "antd";
import Media from "react-media";
import { Swipeable } from "react-swipeable";
import { useLocation } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { TreeNode } = TreeSelect;
const { Option } = Select;

const EquipmentForm = (props) => {
  const {
    setParams,
    stateSearch,
    stateStatus,
    stateCategory,
    stateCatType,
    branchList,
    branchID,
    branchCode,
    subCategoryList,
    stateSelectedRegion,
    stateSubCategory,
    branchListLoader,
    stateCatCode,
    stateExclude,
    toggleDrawer,
    setToggleDrawer,
    locationTreeValues,
    categoryTreeValues,
    sort,
    setStateSort,
    sortDir,
    setStateSortDirection,
  } = props;

  const [search, setSearch] = useState(stateSearch || "");
  const [status, setStatus] = useState(stateStatus);
  const [category, setCategory] = useState(stateCategory || "");
  const [catType, setCatType] = useState(stateCatType || "");
  const [selectedRegion, setSelectedRegion] = useState(
    stateSelectedRegion || ""
  );

  const [tempCategory, setTempCategory] = useState("");
  const [subCategory, setSubCategory] = useState(stateSubCategory || "All");
  const [catCode, setCatCode] = useState(stateCatCode);
  const [exclude, setExclude] = useState(stateExclude);

  const [locRef, setLocRef] = useState(null);
  const [catRef, setCatRef] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipVisibleTemp, setTooltipVisibleTemp] = useState(false);
  const [stateExpandedKeys, setStateExpandedKeys] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [stateSearchValue, setStateSearchValue] = useState("");
  const [selectedCategories, setSelectedCategories] = useState(
    stateCategory || ["All"]
  );

  useEffect(() => {
    if (!branchListLoader && branchList.length > 0) {
      if (branchID && branchCode) {
        const defaultBranch = branchList.find(
          (elem) => elem.code === branchCode && elem.id === Number(branchID)
        );
        if (defaultBranch) {
          setSelectedBranch(defaultBranch);
        }
      }
    }
  }, [branchListLoader, branchList]);

  const tooltipTimer = () => {
    if (!tooltipVisible) {
      setTooltipVisible(true);
      setTimeout(() => {
        setTooltipVisible(false);
      }, 2000);
    }
  };

  useEffect(() => {
    if (tooltipVisibleTemp) setTooltipVisible(true);
    const interval = setTimeout(() => {
      setTooltipVisible(tooltipVisibleTemp);
    }, 500);
    return () => {
      clearTimeout(interval);
    };
  }, [tooltipVisibleTemp]);

  const getLocalSuggestions = () => {
    const suggestions = window.localStorage.getItem("Searches");
    if (suggestions) return suggestions.split("||");
    return [];
  };

  const [localSuggestions, setLocalSuggestions] = useState(getLocalSuggestions);
  const saveLocalSuggestion = () => {
    if (search === "") return;
    let tempSuggestions = localSuggestions;
    if (tempSuggestions.length >= 10) {
      tempSuggestions.length = 9;
    }
    tempSuggestions.unshift(search);
    tempSuggestions = [...new Set(tempSuggestions)];
    window.localStorage.setItem("Searches", tempSuggestions.join("||"));
    setLocalSuggestions(tempSuggestions);
  };

  useEffect(() => {
    if (!branchListLoader) {
      submitForm();
    }
  }, [
    search,
    selectedBranch,
    status,
    selectedCategories,
    category,
    setSelectedRegion,
    subCategory,
    catType,
    exclude,
  ]);
  useEffect(() => {
    // Temp is for the search
    if (tempCategory && !branchListLoader) {
      setCategory(tempCategory.type);
      setSubCategory(tempCategory.catType);
      setCatCode(tempCategory.catCode);
      if (!tempCategory.subCategory) {
        setSelectedCategories([
          ...selectedCategories.filter((e) => e !== "All"),
          `{"cat": "${tempCategory.type}", "catType": "${tempCategory.catType}", "catCode": "${tempCategory.catCode}"}`,
        ]);
        setStateSearchValue("");
      } else {
      }
    }
  }, [tempCategory, branchListLoader]);

  const clearForm = () => {
    setSearch("");
    setStatus(1);
    setCatType("");
    setCategory("All");
    setSelectedBranch("All");
    setSelectedRegion("All");
    setExclude(true);
    setSubCategory("");
    setSelectedCategories(["All"]);
    setCatCode("");
    setStateSort("rank");
    setStateSortDirection("Desc");
    setStateSearchValue("");
    setStateExpandedKeys([]);
  };
  const location = useLocation();

  useEffect(() => {
    if (location.search.includes("clear=true")) {
      clearForm();
    }
  }, [location]);

  const submitForm = () => {
    setParams({
      search,
      status,
      category,
      catType,
      selectedCategories,
      branchID: selectedBranch ? selectedBranch.id : "",
      branchCode: selectedBranch ? selectedBranch.code : "",
      selectedRegion,
      subCategory,
      exclude,
      catCode,
    });
  };

  const handleClose = (e, type) => {
    if (e && e.keyCode === 13) {
      if (e.target) {
        e.target.blur();
      }
      if (locRef && type === "loc") {
        // locRef.click();
        locRef.blur();
      }
      if (catRef && type === "cat") {
        // catRef.click();
        catRef.blur();
      }
    }
  };
  const equipmentForm = (mobile) => (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submitForm();
        console.log("submit?");
        saveLocalSuggestion();
      }}
    >
      <div className="searchContainer">
        <div className="searchForm">
          <div
            onKeyUp={(e) => handleClose(e, "auto")}
            onTouchEnd={(e) => handleClose(e, "loc")}
          >
            <label>Search</label>
            <div className="formIcons">
              <AutoComplete
                //"Search for equipment descriptions or Product Number"
                defaultActiveFirstOption={false}
                value={search}
                defaultValue={search}
                dataSource={localSuggestions}
                filterOption={(value, option) => {
                  return option.key.includes(search);
                }}
                onChange={(value) => setSearch(value)}
              />
              <Tooltip
                placement="right"
                title="Use a comma to separate words or product numbers."
              >
                <ExclamationCircleOutlined className="formIconsIcon" />
              </Tooltip>
            </div>
          </div>
          <div>
            <label>Status</label>
            <div className="formIcons">
              <TreeSelect
                treeDefaultExpandAll
                style={{ minWidth: "230px" }}
                value={status}
                onSelect={(value) => {
                  setStatus(value);
                }}
              >
                <TreeNode key={`status1`} value={0} title="All" />
                <TreeNode key={`status2`} value={1} title="In">
                  <TreeNode key={`status3`} value={3} title="Reserved" />
                </TreeNode>
                <TreeNode key={`status4`} value={2} title="Out">
                  <TreeNode key={`status5`} value={4} title="Terminated" />
                </TreeNode>
              </TreeSelect>
            </div>
          </div>
          <div
            onKeyUp={(e) => handleClose(e, "loc")}
            onTouchEnd={(e) => handleClose(e, "loc")}
          >
            <label>Location</label>
            <div className="formIcons">
              <TreeSelect
                onBlur={(e) => {
                  if (!locRef) {
                    setLocRef(e.target);
                  }
                }}
                className="testTree"
                showSearch
                onSearch={(e) => {
                  let search = e.toLowerCase();
                  if (search.length < 3) return;

                  let searchedBranch = branchList.filter((branch) => {
                    let desc = branch.description.toLowerCase();
                    if (
                      branch.code.startsWith(search) ||
                      desc.startsWith(search) ||
                      `${branch.code} ${desc}`.startsWith(search)
                    ) {
                      return true;
                    }
                    return false;
                  });
                  if (searchedBranch.length === 1) {
                    setStateSearchValue("");
                    setSelectedBranch(searchedBranch[0]);
                  }
                }}
                dropdownStyle={{ maxHeight: 300 }}
                onSelect={(value, moreData) => {
                  if (moreData.props.region) {
                    setSelectedBranch({});
                    setSelectedRegion(value);
                  } else {
                    setSelectedRegion("");
                    setSelectedBranch(moreData.props);
                  }
                }}
                value={
                  selectedBranch && selectedBranch.description
                    ? selectedBranch.description === "All"
                      ? selectedBranch.description
                      : `${selectedBranch.code} ${selectedBranch.description}`
                    : selectedRegion
                }
                treeData={locationTreeValues}
              />
            </div>
          </div>
          <div
            onKeyUp={(e) => handleClose(e, "cat")}
            onTouchEnd={(e) => handleClose(e, "cat")}
          >
            <label>Category</label>
            <div className="formIcons">
              <TreeSelect
                onBlur={(e) => {
                  if (!catRef) {
                    setCatRef(e.target);
                  }
                }}
                onTreeExpand={(e) => setStateExpandedKeys(e)}
                treeExpandedKeys={stateExpandedKeys}
                searchValue={stateSearchValue}
                onSearch={(e) => {
                  setStateSearchValue(e);
                  let search = e.toLowerCase();
                  if (search.length < 3) return;
                  let searchedCat = subCategoryList.filter((cat) => {
                    let type = cat.type.toLowerCase();
                    let catType = cat.catType.toLowerCase();
                    return (
                      type.startsWith(search) ||
                      `${type} ${catType}`.startsWith(search)
                    );
                  });
                  if (searchedCat.length === 1) {
                    setTempCategory(searchedCat[0]);
                  }
                }}
                filterTreeNode={(search, node) => {
                  let { title } = node.props;
                  search = search.toLowerCase();
                  title = title.toLowerCase();
                  if (title === "all") {
                    return title.startsWith(search);
                  }
                  title = title.toLowerCase();
                  if (title.startsWith(search)) {
                    return true;
                  }
                  return false;
                }}
                treeCheckable
                showCheckedStrategy="SHOW_PARENT"
                multiple
                showSearch
                style={{ minWidth: "230px" }}
                dropdownStyle={{ maxHeight: 300 }}
                onChange={(cats, label, extra) => {
                  if (cats.length === 0 || extra.triggerValue === "All") {
                    setSelectedCategories(["All"]);
                    return;
                  }
                  if (cats.length >= 11) {
                    tooltipTimer();
                    return;
                  }
                  let allIndex = cats.findIndex((e) => e === "All");
                  if (allIndex !== -1) cats.splice(allIndex, 1);
                  setSelectedCategories(cats);
                  return;
                }}
                value={selectedCategories}
                treeData={categoryTreeValues}
              />
              <div
                onMouseEnter={() => {
                  setTooltipVisibleTemp(true);
                }}
                onMouseLeave={() => {
                  setTooltipVisibleTemp(false);
                }}
              >
                <Tooltip
                  visible={tooltipVisible}
                  placement="right"
                  title="Only 10 Categories can be selected at a time."
                >
                  <ExclamationCircleOutlined className="formIconsIcon" />
                </Tooltip>
              </div>
            </div>
          </div>
          <div className={"Clear"}>
            <Checkbox
              checked={exclude}
              onChange={() => {
                setExclude(!exclude);
              }}
            >
              Exclude in Repair
            </Checkbox>
            <div onClick={clearForm}>Clear All</div>
          </div>
          {mobile && (
            <div>
              <h2>Sort By:</h2>
              <div className="SortByForm">
                <div>
                  <label>Field</label>
                  <Select value={sort} onChange={(e) => setStateSort(e)}>
                    <Option value="rank">Relevance</Option>
                    <Option value="fldDesc">Description</Option>
                    <Option value="branchCode">Branch</Option>
                    <Option value="fleetNo">Product</Option>
                    <Option value="type">Category</Option>
                    <Option value="regionCode">Region</Option>
                  </Select>
                </div>
                <div>
                  <label>Order</label>
                  <Select
                    value={sortDir}
                    onChange={(e) => setStateSortDirection(e)}
                  >
                    <Option value="Asc">Ascending</Option>
                    <Option value="Desc">Descending </Option>
                  </Select>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </form>
  );

  const mobileForm = () => (
    <>
      <div className="flexEnd">
        <div className="SortButton">
          <Icon type="search" onClick={() => setToggleDrawer(true)} />
        </div>
      </div>
      <Drawer
        width="90vw"
        title="Filtered by:"
        placement="right"
        closable={false}
        visible={toggleDrawer}
        onClose={() => setToggleDrawer(false)}
      >
        <Swipeable
          onSwipedRight={() => {
            setToggleDrawer(false);
          }}
          onSwipedLeft={() => setToggleDrawer(true)}
        >
          <div className="wass">
            {equipmentForm(true)}
            <h3>
              Quick Tip: You can open this menu just by swiping left on your
              screen.
            </h3>
          </div>
        </Swipeable>
      </Drawer>
    </>
  );
  return (
    <Media query="(max-width: 720px)">
      {(matches) => (matches ? mobileForm() : equipmentForm())}
    </Media>
  );
};

export default EquipmentForm;
